module.exports = function(done, value){
  return {value: value, done: !!done};
};


//////////////////
// WEBPACK FOOTER
// ../node_modules/core-js/modules/$.iter-step.js
// module id = 131
// module chunks = 0